<template>
    <div class="index list" @scroll="onScroll">
        <div class="index-mainBackground">
        </div>
        <div class="index-item">
            <div class="card">
                <div class="card-left">
                    <img v-if="shopDetails.shop_img" :src="shopDetails.shop_img" alt="">
                    <img v-else src="../../assets/icon/home/icon_fjmd.png" />
                    <div class="card-content">
                        <div class="card-content-name">{{ shopDetails.name }}</div>
                        <div class="card-content-address">{{ shopDetails.address }}</div>
                    </div>
                </div>
            </div>
            <div class="txt"><span>本店在售产品</span></div>
            <div class="card" v-if="shopGoodslist > 0">
                <div class="">
                    <div v-for="(item, index) of shopGoodslist" :key="index">
                        <div class="card-left">
                            <img :src="item.product_img" alt="">
                            <div class="card-content">
                                <div class="card-content-name">{{ item.product_name }}</div>
                                <div class="card-content-address">{{ item.spec }}</div>
                            </div>
                        </div>
                        <!-- <div class="card-right"><img src="../../assets/icon/right.png" /></div> -->
                    </div>
                </div>
            </div>
            <div class="index-empty">
                <img src="../../assets/icon/img_zanwu.png" alt="">
            </div>
        </div>
        <div class="index-btn">
            <button @click="callShop(shopDetails.mobile)">电话订货</button>
            <button @click="navigationShop">门店导航</button>
        </div>
        <div class="index-logo">
            <img src="../../assets/img/logo.png">
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Dialog } from 'vant'
Vue.use(Dialog).use(Toast)
export default {
    name: 'ShopDetails',
    data() {
        return {
            shopDetails: {},
            shopGoodslist: [],
            total: 10,
            page: 1,
            size: 10
        }
    },
    created() {
        console.log(this.$route.params)
        this.shopDetails = this.$route.params
        console.log(this.shopDetails)
        if (this.shopDetails.id) {
            this.getShopGoods()
        }
    },
    methods: {
        onScroll(event) {
            const { scrollTop, clientHeight, scrollHeight } = event.target;
            // 当滚动到底部时触发加载
            if (scrollTop + clientHeight === scrollHeight) {
                console.log('触底了哈哈哈哈')
                if (this.total > this.page * this.size) {
                    this.page += 1
                    this.getShopGoods()
                }

            }
        },
        toDetails() {
            this.$router.push({ name: 'ShopDetails' })
        },
        getShopGoods() {
            let that = this;
            const url = `/shop/goods/?shop_id=${this.shopDetails.id}&page=${this.page}&size=${this.size}`
            this.axios.get(url).then(function (res) {
                if (res.data) {
                    that.shopGoodslist = that.shopGoodslist.concat(res.data.records)
                    that.total = res.data.total
                }
                if (res.data.records.length == 0) that.shopGoodslist = res.data.records
            }).catch(function (error) {
                console.log(error)
            })
        },
        callShop(phonenumber) {
            window.location.href = 'tel://' + phonenumber
        },
        navigationShop() {
            this.wx.openLocation({
                latitude: this.shopDetails.latitude, // 纬度，浮点数，范围为90 ~ -90
                longitude: this.shopDetails.longitude, // 经度，浮点数，范围为180 ~ -180。
                name: this.shopDetails.name, // 位置名
                address: this.shopDetails.address, // 地址详情说明
                scale: 1, // 地图缩放级别,整型值,范围从1~28。默认为最大
                infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转,
                success(e) {
                },
                fail(e) {
                    console.log(e)
                    Dialog({ message: '打开失败' })
                }
            });

        }
    }
}

</script>

<style lang="scss" scoped>
.index {
    &-mainBackground {
        width: 100vw;
        position: absolute;
        top: 0;
        height: 233px;
        background: linear-gradient(180deg, #FFE09A 0%, #F6F8FA 100%);
        // z-index: -1;
    }

    &-item {
        position: relative;
        display: flex;
        flex-direction: column;
        margin-left: 15px;
        margin-right: 15px;
    }

    &-empty {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            margin-top: 10%;
            width: 200px;
            height: 200px;
        }
    }

    .txt {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 10px;
        font-weight: 400;
        font-size: 14px;
        color: #718096;
    }

    .card {
        margin-top: 10px;
        display: flex;
        // align-items: center;
        background: #FFFFFF;
        border-radius: 16px;
        padding: 0px 15px 15px 15px;
        justify-content: space-between;
        flex-direction: column;

        &-left {
            display: flex;
            align-items: center;
            margin-top: 15px;

            img {
                width: 60px;
                height: 60px;
                margin-right: 15px;
                flex-shrink: 0;
                border-radius: 5px;
            }
        }

        &-content {
            height: 100%;

            // position: relative;
            &-name {
                flex: 1;
                margin-bottom: 15px;
                flex-shrink: 0;
                font-weight: 500;
                font-size: 14px;
                color: #111827;
            }

            &-address {
                flex: 1;
                flex-shrink: 0;
                font-weight: 400;
                font-size: 14px;
                color: #718096;
                flex-wrap: wrap;

            }
        }

        &-right {

            img {
                flex-shrink: 0;
                width: 20px;
                height: 20px;
                border-radius: 5px;

            }
        }
    }

    &-btn {
        position: fixed;
        bottom: 35px;
        left: 0;
        right: 0;
        padding-bottom: 20px;

        /* 兼容 iOS >= 11.2 */
        margin-left: 5px;
        margin-right: 5px;
        display: flex;


        button {
            width: 100%;
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 15px;
            padding-bottom: 15px;
            background: #FAC859;
            box-shadow: 0px 4px 8px 0px rgba(250, 200, 89, 0.11);
            border-radius: 12px;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            border-style: none;
            font-style: normal;
            margin: 5px;
        }
    }

    &-logo {
        // position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 30px;
        right: 16px;
        left: 16px;
        padding-top: 20px;
        padding-bottom: 50px;

        img {
            width: 120px;
            height: 30px;
        }

    }

}

.list {
    overflow-y: scroll;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/shop/details.vue